import { useEffect, useState } from "react";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export type AgentInstallCommand = {
  serverId: string;
  command: string;
};

export type AgentInstallDialogProps = {
  command: AgentInstallCommand | null;
  onOpenChange: (open: boolean) => void;
};

export function AgentInstallDialog({ command, onOpenChange }: AgentInstallDialogProps) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    setCopied(false);
  }, [command?.command]);

  const copyCommand = async () => {
    if (!command) return;
    await navigator.clipboard.writeText(command.command);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Dialog open={Boolean(command)} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Подключение Host Agent</DialogTitle>
          <DialogDescription>
            Выполни эту команду в консоли целевого сервера от root. Входящий SSH к серверу для работы Agent не нужен.
          </DialogDescription>
        </DialogHeader>
        <div className="rounded-lg border border-border bg-muted/40 p-4">
          <code className="block whitespace-pre-wrap break-all text-xs">{command?.command}</code>
        </div>
        <Button onClick={() => void copyCommand()} disabled={copied}>
          {copied ? <Check /> : null}
          {copied ? "Скопировано" : "Скопировать команду"}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
